(function () {
  const initGalleryLightbox = () => {
    const focusableSelector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const sections = document.querySelectorAll('[data-gallery]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const items = Array.from(section.querySelectorAll('[data-gallery-item]'));
      if (!items.length) return;

      const modal = section.querySelector('[data-gallery-modal]');
      const image = section.querySelector('[data-gallery-image]');
      const caption = section.querySelector('[data-gallery-caption]');
      const closeButton = section.querySelector('[data-gallery-close]');
      const prevButton = section.querySelector('[data-gallery-prev]');
      const nextButton = section.querySelector('[data-gallery-next]');
      if (!modal || !image || !caption || !closeButton || !prevButton || !nextButton) return;

      let index = 0;
      let lastTrigger = null;

      const setImage = (nextIndex) => {
        const item = items[nextIndex];
        if (!item) return;
        index = nextIndex;
        image.src = item.dataset.full || '';
        image.alt = item.dataset.alt || '';
        caption.textContent = item.dataset.caption || '';
      };

      const openModal = (nextIndex) => {
        setImage(nextIndex);
        lastTrigger = items[nextIndex] || document.activeElement;
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
          closeButton.focus();
        });
      };

      const closeModal = () => {
        if (modal.classList.contains('hidden')) return;
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus();
        }
      };

      const showNext = () => {
        const nextIndex = (index + 1) % items.length;
        setImage(nextIndex);
      };

      const showPrev = () => {
        const prevIndex = (index - 1 + items.length) % items.length;
        setImage(prevIndex);
      };

      items.forEach((item, itemIndex) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          openModal(itemIndex);
        });
      });

      closeButton.addEventListener('click', closeModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
      prevButton.addEventListener('click', showPrev);
      nextButton.addEventListener('click', showNext);

      window.addEventListener('keydown', (event) => {
        if (modal.classList.contains('hidden')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNext();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPrev();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusables = Array.from(modal.querySelectorAll(focusableSelector)).filter(
          (el) => !el.hasAttribute('hidden') && !el.closest('[hidden]')
        );
        if (focusables.length === 0) {
          event.preventDefault();
          modal.focus();
          return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const activeEl = document.activeElement;

        if (event.shiftKey && activeEl === first) {
          event.preventDefault();
          last.focus();
          return;
        }

        if (!event.shiftKey && activeEl === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryLightbox);
  } else {
    initGalleryLightbox();
  }
})();
